import { Statistic } from "antd";

export const ReportStatistic = function({ name, count }) {
    return (
        <Statistic
            title={name.split(" - ").pop()}
            value={count}
            loading={typeof count === "undefined"}
            valueStyle={{ "text-align": "center" }}
        />
    );
};
